module.exports = __webpack_public_path__ + "img/menu-ibc.74be39a.svg";